import { Navigate, Route, Routes } from "react-router-dom";
import { Playground } from "../pages/playground/Playground";
import { Usage } from "../pages/usage/Usage";
import { Profile } from "../pages/profile/Profile";
import { SignIn } from "../pages/authentication/sign-in/SignIn";
import { SignUp } from "../pages/authentication/sign-up/SignUp";
import { PostCodes } from "../pages/postcodes/PostCodes";
import { Collections } from "../pages/collections/Collections";
import { PlanAndPayment } from "../pages/plan-payment/PlanAndPayment";
import { ForgotPassword } from "../pages/authentication/forgot-password/ForgotPassword";
import { ResetPassword } from "../pages/authentication/reset-password/ResetPassword";
import { ComingSoon } from "../pages/coming-soon/ComingSoon";
import UpdateNews from "../pages/update-news/UpdateNews";
import DocsEmbed from "../pages/documentation/DocsEmbed";
import { Asins } from "../pages/asins/Asins";
import { CatalogScanner } from "../pages/repco/CatalogScanner";
import { VehicleFitment } from "../pages/repco/VehicleFitment";
import DownloadOutput from "../pages/download/DownloadOutput";
import { ErrorLogs } from "../pages/error-logs/ErrorLogs";
import OtpVerify from "../pages/authentication/validation/OtpVerify";
import { Dashboard } from "../pages/dashboard/Dashboard";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/playground" element={<Playground />} />
      <Route path="/collections" element={<Collections />} />
      <Route path="/collections/:id" element={<Collections />} />

      <Route path="/collections/:id/records" element={<Asins />} />
      <Route path="/collections/:id/download" element={<DownloadOutput />} />

      <Route path="/repco/catalog" element={<CatalogScanner />} />
      <Route path="/repco/vehicles" element={<VehicleFitment />} />

      <Route path="/postcodes" element={<PostCodes />} />

      <Route path="/account" element={<PlanAndPayment />} />
      <Route path="/usage" element={<Usage />} />
      <Route path="/profile" element={<Profile />} />

      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/sign-up/verify" element={<OtpVerify />} />
      <Route path="/password/forgot" element={<ForgotPassword />} />
      <Route path="/password/reset" element={<ResetPassword />} />
      <Route path="/update-news" element={<UpdateNews />} />
      <Route path="/documentation" element={<DocsEmbed />} />
      {/* legacy routes -> new embedded docs */}
      <Route path="/documentation-list" element={<Navigate to="/documentation" replace />} />
      <Route path="/documentation/:id" element={<Navigate to="/documentation" replace />} />
      <Route path="/error-logs" element={<ErrorLogs />} />

      <Route path="*" element={<ComingSoon />} />
    </Routes>
  );
};
